import joi from 'joi';
import { z } from 'zod';

export const POST_DISCOVERY_ACTION_GRAPH_CACHE = 'graphCache';
export const POST_DISCOVERY_ACTION_HISTORICAL_DATA = 'historicalData';
export const POST_DISCOVERY_ACTION_INTENT_VERIFICATION = 'intentVerification';

export const postDiscoveryActions = [
  POST_DISCOVERY_ACTION_GRAPH_CACHE,
  POST_DISCOVERY_ACTION_HISTORICAL_DATA,
  POST_DISCOVERY_ACTION_INTENT_VERIFICATION,
] as const;

export type PostDiscoveryAction = (typeof postDiscoveryActions)[number];

export type DisabledPostDiscoveryActions = PostDiscoveryAction[];

export const disabledPostDiscoveryActionsSchema = joi
  .array()
  .items(joi.string().valid(...postDiscoveryActions))
  .unique();

export const disabledPostDiscoveryActionsSchemaZ = z
  .array(z.enum(postDiscoveryActions))
  .refine((data) => data.length === new Set(data).size, {
    message: 'Array items must be unique',
  })
  .optional();
